<template>
  <div class="wrap">
    <div class="item" :key="i.i" :style="{ transform: `translate(${i.px}px, ${i.py}px)`, opacity: i.opacity }" v-for="i in items">{{ emoji }}</div>
  </div>
</template>

<script>
export default {
  props: {
    emoji: {}
  },
  data () {
    return {
      items: []
    }
  },
  mounted () {
    for (var i = 0; i < 50; i++) {
      this.items.push({
        i,
        px: (Math.random() - 0.5) * 700,
        py: 0,
        vy: Math.random() * 5 + 0.3,
        vx: (Math.random() - 0.5),
        opacity: 1.5,
        ov: 0.01
      })
    }
    let raf = () => {
      this.rAFID = window.requestAnimationFrame(raf)
      this.items.forEach((i) => {
        i.py -= i.vy
        i.px -= i.vx

        if (i.opacity > 0) {
          i.opacity -= i.ov
        } else {
          window.cancelAnimationFrame(this.rAFID)
          this.$emit('close')
        }
      })
    }
    this.rAFID = window.requestAnimationFrame(raf)
  },
  beforeDestroy () {
    window.cancelAnimationFrame(this.rAFID)
  }
}
</script>

<style scoped>
.wrap{
  width: 100%;
  position: relative;
}
.item{
  position: absolute;
  bottom: 0px;
  width: 100px;
  left: calc(50% - 50px);
  font-size: 30px;
}
</style>
